import React, { useState, useEffect } from 'react';
import { Layout, Typography, Card, Button, message, Modal, Input, List, Collapse } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import axios from 'axios';
import { apiUrl } from './config';
import { useUser } from '../context/UserContext';
import { useNavigate } from 'react-router-dom';
import trainers from '../data/trainers.json';

const { Content } = Layout;
const { Text } = Typography;

const DailyWorkout = () => {
  const [wodData, setWodData] = useState({ general: null, trainers: [] });
  const [modalVisible, setModalVisible] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [workoutPlanName, setWorkoutPlanName] = useState('');
  const [description, setDescription] = useState('');
  const { user } = useUser();
  const navigate = useNavigate();
  const [historicalWODs, setHistoricalWODs] = useState({});
  const [historicalModalVisible, setHistoricalModalVisible] = useState(false);
  const [selectedTrainerId, setSelectedTrainerId] = useState(null);


  const fetchWODData = async () => {
    try {
      const response = await axios.get(`${apiUrl}/api/wod`);
      setWodData(response.data);
    } catch (error) {
      message.error('Errore nel caricamento dei WOD attivi');
    }
  };
  

  useEffect(() => {
    fetchWODData();
  }, []);

  const fetchHistoricalWODs = async (trainerId) => {
    try {
      const response = await axios.get(`${apiUrl}/api/wod/historical/${trainerId}`);
      const groupedWODs = response.data.reduce((acc, wod) => {
        // Prima qui c'era moment, una libreria intera per questa sola riga, e
        // per giunta mai dichiarata fra le dipendenze: in locale c'era, sul
        // server di pubblicazione no, e la compilazione si fermava li'.
        const date = new Date(wod.updatedAt).toLocaleDateString('it-IT', {
            day: '2-digit', month: '2-digit', year: 'numeric',
        });
        if (!acc[date]) acc[date] = [];
        acc[date].push(wod);
        return acc;
      }, {});
  
      setHistoricalWODs(groupedWODs);
      setSelectedTrainerId(trainerId);
      setHistoricalModalVisible(true);
    } catch (error) {
      message.error('Errore nel caricamento dello storico dei WOD');
    }
  };

  const handleSelectHistoricalWOD = async (selectedWOD) => {
    const payload = {
      workoutPlanName: selectedWOD.workoutPlanName,
      description: selectedWOD.description,
      trainerId: selectedTrainerId,
      isGeneral: false,
    };
  
    try {
      await axios.post(`${apiUrl}/api/wod/save`, payload);
      message.success('WOD selezionato e aggiunto con successo');
      setHistoricalModalVisible(false);
      fetchWODData();
    } catch (error) {
      message.error('Errore nel salvataggio del WOD selezionato');
    }
  };
  
  

  const handleAddOrEditWOD = (isGeneral, trainerId = null, currentWOD = {}) => {
    setModalData({ isGeneral, trainerId });
    setWorkoutPlanName(currentWOD.workoutPlanName || '');
    setDescription(currentWOD.description || '');
    setModalVisible(true);
  };

  const handleModalClose = async () => {
    setModalVisible(false);
    setModalData(null);
    await fetchWODData();
  };

  const handleSaveWOD = async () => {
    const payload = {
      workoutPlanName,
      description,
      trainerId: modalData.trainerId,
      isGeneral: modalData.isGeneral,
    };

    try {
      await axios.post(`${apiUrl}/api/wod/save`, payload);
      message.success('WOD salvato con successo');
      handleModalClose();
    } catch (error) {
      message.error('Errore nel salvataggio del WOD');
    }
  };

  const confirmDeleteWOD = (isGeneral, trainerId) => {
    Modal.confirm({
      title: 'Conferma Eliminazione',
      content: 'Sei sicuro di voler eliminare questo WOD?',
      okText: 'Sì, elimina',
      cancelText: 'Annulla',
      onOk: () => handleDeleteWOD(isGeneral, trainerId),
    });
  };

  const handleDeleteWOD = async (isGeneral, trainerId) => {
    try {
      await axios.delete(`${apiUrl}/api/wod/delete`, { data: { isGeneral, trainerId } });
      message.success('WOD eliminato con successo');
      fetchWODData();
    } catch (error) {
      message.error('Errore durante l\'eliminazione del WOD');
    }
  };

  const goToDetails = (id) => {
    navigate(`/wod-details/${id}`);
  };

  return (
    <Layout style={{ minHeight: '100vh', padding: '20px' }}>
      <Content style={{ textAlign: 'center' }}>
      <div className="wod">
                    WORKOUT OF THE DAY
                </div>
        
        {/* Sezione per WOD Generale */}
        {(user?.role === 'trainer' || wodData.general) && (
          <div style={{ marginBottom: '20px' }}>
            <div className="subtitle-wod">
              WOD Generale
            </div>
            <Card
              style={{ 
                width: '100%', 
                cursor: wodData.general ? 'pointer' : 'default', 
                transition: 'transform 0.2s', 
                boxShadow: wodData.general ? '0 4px 8px rgba(0, 0, 0, 0.15)' : 'none' 
              }}
              hoverable={!!wodData.general}
              onClick={() => wodData.general && goToDetails(wodData.general._id)}
              onMouseEnter={(e) => (e.currentTarget.style.transform = wodData.general ? 'scale(1.02)' : 'none')}
              onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
            >
              {wodData.general ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <Text>{wodData.general.workoutPlanName}</Text>
                  <RightOutlined style={{ fontSize: '16px', color: 'var(--primario)', marginLeft: '10px' }} />
                </div>
              ) : (
                <Text>Nessun WOD Generale inserito</Text>
              )}
              {user?.trainerId && (
                <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'center' }}>
                  <Button
                    type="primary"
                    style={{ marginRight: '10px' }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleAddOrEditWOD(true, null, wodData.general || {});
                    }}
                  >
                    {wodData.general ? 'Modifica WOD' : 'Aggiungi WOD'}
                  </Button>
                  {wodData.general && (
                    <Button
                      type="primary"
                      danger
                      style={{ backgroundColor: 'red', color: 'white' }}
                      onClick={(e) => {
                        e.stopPropagation();
                        confirmDeleteWOD(true, null);
                      }}
                    >
                      Cancella WOD
                    </Button>
                  )}
                </div>
              )}
            </Card>
          </div>
        )}

        {/* Sezione per i WOD per ciascun trainer */}
        {trainers.map((trainer) => {
          const trainerWOD = wodData.trainers.find(w => w.trainerId.toString() === trainer.id.toString());

          return (
            (user?.role === 'trainer' || trainerWOD) && (
              <div key={trainer.id} style={{ marginTop: '40px' }}>
                <div className="subtitle-wod">
                  WOD by {trainer.name}
                </div>
                <Card
                  style={{ 
                    width: '100%', 
                    cursor: trainerWOD ? 'pointer' : 'default', 
                    transition: 'transform 0.2s', 
                    boxShadow: trainerWOD ? '0 4px 8px rgba(0, 0, 0, 0.15)' : 'none' 
                  }}
                  hoverable={!!trainerWOD}
                  onClick={() => trainerWOD && goToDetails(trainerWOD._id)}
                  onMouseEnter={(e) => (e.currentTarget.style.transform = trainerWOD ? 'scale(1.02)' : 'none')}
                  onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                >
                  {trainerWOD ? (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <Text>{trainerWOD.workoutPlanName}</Text>
                      <RightOutlined style={{ fontSize: '16px', color: 'var(--primario)', marginLeft: '10px' }} />
                    </div>
                  ) : (
                    <Text>WOD non inserito</Text>
                  )}
                  {user?.trainerId?.toString() === trainer.id.toString() && (
                    <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'center' }}>
                      <Button
                        type="primary"
                        style={{ marginRight: '10px' }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleAddOrEditWOD(false, trainer.id, trainerWOD || {});
                        }}
                      >
                        {trainerWOD ? 'Modifica WOD' : 'Aggiungi WOD'}
                      </Button>
                      {trainerWOD && (
                        <Button
                          type="primary"
                          danger
                          style={{ backgroundColor: 'red', color: 'white' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            confirmDeleteWOD(false, trainer.id);
                          }}
                        >
                          Cancella WOD
                        </Button>
                      )}
                        <Button
                          type="primary"
                          danger
                          style={{ backgroundColor: 'red', color: 'white', marginLeft: '10px' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            fetchHistoricalWODs(trainer.id);
                          }}
                        >
                          Storico WOD
                        </Button>
                    </div>
                  )}
                </Card>
              </div>
            )
          );
        })}

        {/* Modal per aggiungere/modificare WOD */}
        <Modal
          open={modalVisible}
          title={modalData?.isGeneral ? 'Modifica WOD Generale' : 'Modifica WOD del Trainer'}
          onCancel={handleModalClose}
          onOk={handleSaveWOD}
          okText="Salva"
          cancelText="Annulla"
          getContainer={document.body}
        >
          <Input
            value={workoutPlanName}
            onChange={(e) => setWorkoutPlanName(e.target.value)}
            placeholder="Nome del WOD"
            style={{ marginBottom: '10px' }}
          />
          <Input.TextArea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Inserisci il contenuto del WOD (separato da linee per elenco)"
            rows={4}
          />
        </Modal>

<Modal
  open={historicalModalVisible}
  title="Storico WOD"
  getContainer={document.body}
  onCancel={() => setHistoricalModalVisible(false)}
  footer={null}
>
  {Object.keys(historicalWODs).length > 0 ? (
    <Collapse accordion>
      {Object.keys(historicalWODs).map((date) => (
        <Collapse.Panel header={`WOD del ${date}`} key={date}>
          <List
            dataSource={historicalWODs[date]}
            renderItem={(item) => (
              <Collapse>
                <Collapse.Panel header={item.workoutPlanName} key={item._id}>
                  <Text strong>Descrizione:</Text>

                  {/* Trasforma la descrizione in una lista di esercizi */}
                  <List
                    dataSource={item.description.split('\n').filter(line => line.trim() !== '')}
                    renderItem={(exercise, index) => (
                      <List.Item>
                        <Text>{exercise}</Text>
                      </List.Item>
                    )}
                  />

                  <Button type="primary" style={{ marginTop: '10px' }} onClick={() => handleSelectHistoricalWOD(item)}>
                    Aggiungi a Oggi
                  </Button>
                </Collapse.Panel>
              </Collapse>
            )}
          />
        </Collapse.Panel>
      ))}
    </Collapse>
  ) : (
    <Text>Nessun WOD storico disponibile</Text>
  )}
</Modal>

      </Content>
    </Layout>
  );
};

export default DailyWorkout;
